module.exports = __webpack_public_path__ + "img/sdk4.9da681e4.png";